import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchRoutes, fetchStops, clearEditStatus, fetchUnassignedOrders, assignOrderRoute, saveEditedStops } from '../../actions/dispatch_actions';
import { printDispatchRoute, printDispatchPickingList, printDispatchPackingList, printDispatchSalesInvoice } from '../../actions/print_actions';

import Routing from '../../components/Dispatch/routing';

const routing = reduxForm({
  form: 'routing',
  // validate
})(Routing);

const selector = formValueSelector('routing');

function mapStateToProps(state) {
  const dateChosen = selector(state, 'DeliverDate');

  return {
    dateChosen,

    routes: state.dispatch.routes,
    routesIsLoading: state.dispatch.routesIsLoading,
    routesError: state.dispatch.routesError,

    stops: state.dispatch.stops,
    stopsIsLoading: state.dispatch.stopsIsLoading,
    stopsError: state.dispatch.stopsError,
    savingEditedStops: state.dispatch.savingEditedStops,

    unassignedOrders: state.dispatch.unassignedOrders,
    unassignedOrdersIsLoading: state.dispatch.unassignedOrdersIsLoading,
    unassignedOrdersError: state.dispatch.unassignedOrdersError,
    assigningOrderRoute: state.dispatch.assigningOrderRoute,
    userPermissions: state.auth.userPermissions,

    requestingRoutingPdf: state.print.requestingRoutingPdf,
    routingPdf: state.print.routingPdf,
    routingPdfFailure: state.print.routingPdfFailure,

    requestingPickingListPdf: state.print.requestingPickingListPdf,
    pickingListPdf: state.print.pickingListPdf,
    pickingListPdfFailure: state.print.pickingListPdfFailure,

    requestingPackingListPdf: state.print.requestingPackingListPdf,
    packingListPdf: state.print.packingListPdf,
    packingListPdfFailure: state.print.packingListPdfFailure,

    requestingDispatchSalesInvoicePdf: state.print.requestingDispatchSalesInvoicePdf,
    dispatchSalesInvoicePdf: state.print.dispatchSalesInvoicePdf,
    dispatchSalesInvoicePdfFailure: state.print.dispatchSalesInvoicePdfFailure,
    
    selectedWarehouse: state.header.selectedWarehouse,
  };
}

export default connect(mapStateToProps, {
  fetchRoutes,
  fetchStops,
  clearEditStatus,
  fetchUnassignedOrders,
  assignOrderRoute,
  saveEditedStops,
  printDispatchRoute,
  printDispatchPickingList,
  printDispatchPackingList,
  printDispatchSalesInvoice,
})(routing);



// WEBPACK FOOTER //
// ./master/jsx/containers/Dispatch/routing.jsx